<template>
  <div class="City21">
    <div class="city">
      <div class="ReportTitle">
        <span>省内各地网信部门举报频道</span>
        <i></i>
      </div>
      <van-grid :gutter="10"
                :column-num="3">
        <van-grid-item v-for="(value, index) in provinceList"
                       :key="index"
                       :text="value.name"
                       @click="toCity(value.link)" />
      </van-grid>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'City21',
  props: {},
  data () {
    return {
      active: 0,
      provinceList: []
    }
  },
  created () {
    this.getCity()
  },
  methods: {
    ...mapMutations(['setShowLoading']),
    getCity () {
      this.$Api.footer().then((res) => {
        if (res && res.blogRoll) {
          this.provinceList = (res.blogRoll || []).slice(1)
        }
      })
    },
    toCity (url) {
      window.open(url, '_self')
    }
  },
  computed: {},
  watch: {},
  components: {},
  mounted () {
    this.$nextTick(() => {
      this.$Common.pageShare()
      this.setShowLoading(false)
    })
    this.$Common.track('load', {
      applicationId: 'sztf_expo',
      eventYype: 'load',
      name: 'city21',
      refer: document.referrer || window.location.href
    })
  }
}
</script>

<style lang="scss" scoped>
.city {
  height: 100%;
  padding-top: 2vw;
  .ReportTitle {
    position: relative;
    // padding: 5vw 0 5vw 41vw;
    padding-bottom: 5vw;
    font-size: 4.815vw;
    font-weight: 700;
    text-align: center;
    i {
      position: absolute;
      top: 7vw;
      left: 45vw;
      padding-left: 5vw;
      border-bottom: 1vw solid #2e76f3;
    }
  }
  //   span {
  //     margin-left: 2vw;
  //     width: 10%;
  //   }
  ul {
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    margin-top: 2vw;
    margin-left: 0.6vw;
    li {
      width: 40%;
      padding: 4vw 1vw;
      text-align: center;
      font-weight: 700;
      border: 1px solid #dadada;
      white-space: nowrap;
      margin-bottom: 5vw;
      margin-left: 5vw;
    }
  }
}
</style>
